module.exports = __webpack_public_path__ + "img/icon_link_share_g.153b7172.svg";